import { ContentStoreTagsService } from 'src/services/Tags';

export const deleteTag = (
    { accessToken, id }: App.Tag.DeleteMutationVariables,
): Promise<void> => ContentStoreTagsService.deleteTag(accessToken, id);
